import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const AddressSectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  background-color: ${COLORS.bgWhite};
`

export const AddressSectionHeading = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: -0.18px;
  color: ${COLORS.textPrimary};
`

export const AddressInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const AddressBody = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: ${COLORS.textSecondary};
  word-break: keep-all;
`

export const AddressEntranceDetail = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.textMuted};
`

export const AddressChips = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`
